import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {
    AiTranscriptionImproveServicePayload,
    AiTranscriptionImproveServiceResult
} from "./aiTranscriptionImprove.service";
import {environment} from "../../../../../../environments/environment";
import {Payload} from "../../../../core/service/payload/payload";

@Injectable({
    providedIn: 'root'
})
export class AiTranscriptionEntityImproveService {

    constructor(private httpClient: HttpClient){
    }

    execute(payload: AiTranscriptionEntityImproveServicePayload): Promise<AiTranscriptionImproveServiceResult> {
        return this.httpClient.post<AiTranscriptionImproveServiceResult>(environment.webserviceUrl + '/v1/ai/transcription/improve-v2', payload)
            .toPromise();
    }
}

export class AiTranscriptionEntityImproveServicePayload implements Payload{
    common: AiTranscriptionEntityImproveServiceCommonPayload;
    custom: any;
}

export class AiTranscriptionEntityImproveServiceCommonPayload implements Payload{
    transcription: string;
    existingText?: string;
    entityName: string;
}